/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    BrandAndMarketListItem,
    BrandAndMarketListItemFromJSON,
    BrandAndMarketListItemFromJSONTyped,
    BrandAndMarketListItemToJSON,
    CodeAndLabel,
    CodeAndLabelFromJSON,
    CodeAndLabelFromJSONTyped,
    CodeAndLabelToJSON,
    GlobalFilterListOrderValue,
    GlobalFilterListOrderValueFromJSON,
    GlobalFilterListOrderValueFromJSONTyped,
    GlobalFilterListOrderValueToJSON,
    GuidIdAndLabel,
    GuidIdAndLabelFromJSON,
    GuidIdAndLabelFromJSONTyped,
    GuidIdAndLabelToJSON,
    GuidIdCodeAndLabel,
    GuidIdCodeAndLabelFromJSON,
    GuidIdCodeAndLabelFromJSONTyped,
    GuidIdCodeAndLabelToJSON,
    Int32IdAndLabel,
    Int32IdAndLabelFromJSON,
    Int32IdAndLabelFromJSONTyped,
    Int32IdAndLabelToJSON,
    StationOrLocationItem,
    StationOrLocationItemFromJSON,
    StationOrLocationItemFromJSONTyped,
    StationOrLocationItemToJSON,
} from './';

/**
 * 
 * @export
 * @interface GlobalFilterQuery
 */
export interface GlobalFilterQuery {
    /**
     * 
     * @type {BrandAndMarketListItem}
     * @memberof GlobalFilterQuery
     */
    brandAndMarket?: BrandAndMarketListItem;
    /**
     * 
     * @type {Int32IdAndLabel}
     * @memberof GlobalFilterQuery
     */
    distributionChannel?: Int32IdAndLabel;
    /**
     * 
     * @type {GuidIdAndLabel}
     * @memberof GlobalFilterQuery
     */
    agency?: GuidIdAndLabel;
    /**
     * 
     * @type {boolean}
     * @memberof GlobalFilterQuery
     */
    agencyOnly?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof GlobalFilterQuery
     */
    description?: string | null;
    /**
     * 
     * @type {number}
     * @memberof GlobalFilterQuery
     */
    relevance?: number | null;
    /**
     * 
     * @type {CodeAndLabel}
     * @memberof GlobalFilterQuery
     */
    fareType?: CodeAndLabel;
    /**
     * 
     * @type {StationOrLocationItem}
     * @memberof GlobalFilterQuery
     */
    destination?: StationOrLocationItem;
    /**
     * 
     * @type {GuidIdCodeAndLabel}
     * @memberof GlobalFilterQuery
     */
    carrier?: GuidIdCodeAndLabel;
    /**
     * 
     * @type {GuidIdAndLabel}
     * @memberof GlobalFilterQuery
     */
    supplier?: GuidIdAndLabel;
    /**
     * 
     * @type {CodeAndLabel}
     * @memberof GlobalFilterQuery
     */
    allow?: CodeAndLabel;
    /**
     * 
     * @type {boolean}
     * @memberof GlobalFilterQuery
     */
    showDisabled?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GlobalFilterQuery
     */
    showDeleted?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GlobalFilterQuery
     */
    orderByRelevanceAscending?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GlobalFilterQuery
     */
    orderByDescending?: boolean;
    /**
     * 
     * @type {GlobalFilterListOrderValue}
     * @memberof GlobalFilterQuery
     */
    orderValue?: GlobalFilterListOrderValue;
    /**
     * 
     * @type {number}
     * @memberof GlobalFilterQuery
     */
    offset?: number | null;
    /**
     * 
     * @type {number}
     * @memberof GlobalFilterQuery
     */
    limit?: number | null;
}

export function GlobalFilterQueryFromJSON(json: any): GlobalFilterQuery {
    return GlobalFilterQueryFromJSONTyped(json, false);
}

export function GlobalFilterQueryFromJSONTyped(json: any, ignoreDiscriminator: boolean): GlobalFilterQuery {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'brandAndMarket': !exists(json, 'brandAndMarket') ? undefined : BrandAndMarketListItemFromJSON(json['brandAndMarket']),
        'distributionChannel': !exists(json, 'distributionChannel') ? undefined : Int32IdAndLabelFromJSON(json['distributionChannel']),
        'agency': !exists(json, 'agency') ? undefined : GuidIdAndLabelFromJSON(json['agency']),
        'agencyOnly': !exists(json, 'agencyOnly') ? undefined : json['agencyOnly'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'relevance': !exists(json, 'relevance') ? undefined : json['relevance'],
        'fareType': !exists(json, 'fareType') ? undefined : CodeAndLabelFromJSON(json['fareType']),
        'destination': !exists(json, 'destination') ? undefined : StationOrLocationItemFromJSON(json['destination']),
        'carrier': !exists(json, 'carrier') ? undefined : GuidIdCodeAndLabelFromJSON(json['carrier']),
        'supplier': !exists(json, 'supplier') ? undefined : GuidIdAndLabelFromJSON(json['supplier']),
        'allow': !exists(json, 'allow') ? undefined : CodeAndLabelFromJSON(json['allow']),
        'showDisabled': !exists(json, 'showDisabled') ? undefined : json['showDisabled'],
        'showDeleted': !exists(json, 'showDeleted') ? undefined : json['showDeleted'],
        'orderByRelevanceAscending': !exists(json, 'orderByRelevanceAscending') ? undefined : json['orderByRelevanceAscending'],
        'orderByDescending': !exists(json, 'orderByDescending') ? undefined : json['orderByDescending'],
        'orderValue': !exists(json, 'orderValue') ? undefined : GlobalFilterListOrderValueFromJSON(json['orderValue']),
        'offset': !exists(json, 'offset') ? undefined : json['offset'],
        'limit': !exists(json, 'limit') ? undefined : json['limit'],
    };
}

export function GlobalFilterQueryToJSON(value?: GlobalFilterQuery | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'brandAndMarket': BrandAndMarketListItemToJSON(value.brandAndMarket),
        'distributionChannel': Int32IdAndLabelToJSON(value.distributionChannel),
        'agency': GuidIdAndLabelToJSON(value.agency),
        'agencyOnly': value.agencyOnly,
        'description': value.description,
        'relevance': value.relevance,
        'fareType': CodeAndLabelToJSON(value.fareType),
        'destination': StationOrLocationItemToJSON(value.destination),
        'carrier': GuidIdCodeAndLabelToJSON(value.carrier),
        'supplier': GuidIdAndLabelToJSON(value.supplier),
        'allow': CodeAndLabelToJSON(value.allow),
        'showDisabled': value.showDisabled,
        'showDeleted': value.showDeleted,
        'orderByRelevanceAscending': value.orderByRelevanceAscending,
        'orderByDescending': value.orderByDescending,
        'orderValue': GlobalFilterListOrderValueToJSON(value.orderValue),
        'offset': value.offset,
        'limit': value.limit,
    };
}


